module.exports = __webpack_public_path__ + "static/media/21ECLAC30.94eb0e95.jpg";